<script setup lang="ts">
import { LineChart } from 'echarts/charts'
import { use } from 'echarts/core'
import { computed } from 'vue'
import VChart from 'vue-echarts'

import { useTimeChartDateFormat } from '~/composables/useTimeChartDateFormat'
import { CHART_TOOLTIP } from '~/environment-variables/chart.const'

const echarts = await import('echarts')

interface IProps {
  height?: number
  data: [number, string][]
  lineColor?: string
  gradientColor?: string
  formatter: (params: any) => string
  tooltip?: any
}

const props = withDefaults(defineProps<IProps>(), {
  height: 300,
  data: () => [],
  lineColor: '#5C8FFA',
  gradientColor: '#5C8FFA',
  tooltip: {
    backgroundColor: CHART_TOOLTIP.backgroundColor,
    textStyle: CHART_TOOLTIP.textStyle,
  },
})

use([ LineChart ])

const { xAxisData, yAxisData } = useTimeChartDateFormat(props.data)

const chartHeight = computed(() => {
  return `${props.height}px`
})

const lineCHartOption = {
  tooltip: {
    trigger: 'axis',
    position: 'top',
    backgroundColor: props.tooltip.backgroundColor,
    padding: 8,
    borderWidth: 0,
    textStyle: props.tooltip.textStyle,
    formatter: props.formatter,
    axisPointer: {
      color: '#fff',
      axis: 'x',
      label: {
        show: false,
      },
      lineStyle: {
        color: props.lineColor,
      },
    },
  },
  grid: {
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  xAxis: [
    {
      show: false,
      type: 'category',
      boundaryGap: false,
      data: xAxisData,
    },
  ],
  yAxis: [
    {
      show: false,
      type: 'value',
    }
  ],
  series: [
    {
      name: 'Line 1',
      type: 'line',
      stack: 'Total',
      smooth: true,
      color: props.lineColor,
      symbolSize: 8,
      lineStyle: {
        width: 2,
        color: props.lineColor
      },
      showSymbol: false,
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: props.gradientColor
          },
          {
            offset: 1,
            color: props.gradientColor + '08'
          }
        ])
      },
      emphasis: {
        focus: 'series'
      },
      data: yAxisData
    },
  ]
}
</script>

<template>
  <VChart
    class="chart"
    :option="lineCHartOption"
    :style="{ height: chartHeight }"
    autoresize
  />
</template>

<style scoped>
</style>